import { faExclamationTriangle, type IconDefinition } from "@/icons/solid-icons";
import { cn } from "@/utils/css";
import Icon from "../Icon";
import DinesLink from "../Misc/DinesLink";

export interface AlertMessageProps {
  title: string;
  description?: string;
  link?: string;
  linkText?: string;
  className?: string;
  id?: string;
}

const AlertMessage = ({
  title,
  description,
  link,
  linkText,
  className,
  id,
}: AlertMessageProps) => (
  <div
    className={cn(
      "border-red-400 border-l-4 bg-red-50 py-2 pr-8 pl-4",
      className,
    )}
    id={id}
    data-testid={id}
  >
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <Icon
              icon={faExclamationTriangle as IconDefinition}
              className="h-5 w-5 text-red-400"
              aria-hidden="true"
            />
          </div>
          <div className="ml-3">
            <p className="text-red-700" data-testid={`${id}-title`}>
              {title}
            </p>
          </div>
        </div>
        {description && (
          <p className="text-sm" data-testid={`${id}-description`}>
            {description}
          </p>
        )}
      </div>
      {link && linkText && (
        <div>
          <DinesLink href={link}>
            <button
              type="button"
              className="rounded-lg bg-red-500 px-4 py-2 font-bold text-white"
            >
              {linkText}
            </button>
          </DinesLink>
        </div>
      )}
    </div>
  </div>
);

export default AlertMessage;
